import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { translations as translationsApi } from 'redux/modules/api'
import { modal, notification, logError } from 'redux/modules/app'

function decorator() {
  const enhance = compose(
    connect(
      ({ api }) => ({
        local: {},
        translations: api.translations
      }),
      { ...translationsApi, modal, notification, logError }
    )
  )

  return ComposedComponent => {
    class Translations extends Component {
      static propTypes = {
        translations: PropTypes.object.isRequired,
        loadTranslations: PropTypes.func.isRequired,
        loadDefaultTranslation: PropTypes.func.isRequired,
        resetTranslations: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        modal: PropTypes.func
      }

      static defaultProps = {
        params: {}
      }

      handleLoadTranslations = (translationKeyList = [], localeId) => {
        const data = { translationKeyList, localeId }

        this.props.loadTranslations(data)
            .catch(this.handleError)
      }

      handleLoadDefaultTranslations = (translationKeyList = [], localeId) => {
        const data = { translationKeyList, localeId }

        this.props.loadDefaultTranslation(data)
            .catch(this.handleError)
      }

      handleResetTranslations = () => {
        this.props.resetTranslations()
            .catch(this.handleError)
      }


      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        const params = {
          ...this.props,
          local: undefined
        }

        return (
          <ComposedComponent
            {...params}
            onLoadTranslations={this.handleLoadTranslations}
            onLoadDefaultTranslations={this.handleLoadDefaultTranslations}
            onResetTranslations={this.handleResetTranslations}
          />
        )
      }
    }
    return enhance(Translations)
  }
}

export default decorator
